import { FormControlList } from './../../../modules/shared/constants/formcontrol-list.constants';
import { DynamicTableWidgetDetailsM } from './../../../modules/shared/models/dynamic-table/dynamic-table-widget-details.model';
import { DynamicTableWidgetService } from './../../../modules/shared/services/dynamic-table/dynamic-table-widget.service';
import { ConfigDefaultService } from './../../../modules/shared/services/configuration-default.service';
import { PermissionService } from './../../../service/permission.service';
import { ParseHelper } from 'src/app/modules/shared/parse.helper';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { CONTACT_ASSOCIATION_ID, PHONE_TYPE_IDS } from './../../../modules/shared/constants/typeId';
import { Subject, take, takeUntil } from 'rxjs';

// Components
import { AppMainComponent } from '../../../app.main.component';

// Services
import { ConfirmationService, LazyLoadEvent, MessageService } from 'primeng/api';
import { ActivityService } from '../../../shared/shared-activities/activity.service';
import { AppMainService } from '../../../app-main.service';
import { AccountServiceN } from '../../services/account.services'


// Enums and Constants
import { AccountViewTabIndex } from '../../accounts.enum';
import { StoreService } from 'src/app/modules/shared/services/store.service';
import { AccountModuleId } from 'src/app/modules/shared/constants/modules.constant';
import { ChannelN } from 'src/app/modules/shared/models/channel.model';
import { uploadFiles, validateFiles } from 'src/app/shared/upload-files';
import { SharedChannelService } from 'src/app/modules/shared/services/channel.service';
import { FileUpload } from 'primeng/fileupload';
import { DocumentViewerService } from 'src/app/modules/shared/services/document-viewer.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Severity } from 'src/app/inventory/constants/constants';
import { TitleCasePipe } from '@angular/common';
import { ObjectNames } from 'src/app/shared/constants';
import { LocalDatePipe } from '../../../shared/pipes/local-date.pipe';
import { SharedCRMConfigService } from 'src/app/configurations/crm/shared/services/shared-crm-config.service';
import { TemplateSection } from 'src/app/modules/shared/model/templateSection.model';
import { AccountHelper } from '../../services/accounts.helper';
import { Sections } from '../../accounts.constant';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { UpdateColumnSettings, UpdateFields } from 'src/app/modules/shared/models/column-settings.model';
import { AccountsTransactionType, TransactionNames, typeJournalAddEditText } from 'src/app/finance/constants/constants';
import { FormGroup } from '@angular/forms';
import { FinanceService } from 'src/app/finance/finance.service';
import { ReceivePaymentDialogType } from 'src/app/modules/shared/components/receive-payments/constants/constants';
import { AccountService } from 'src/app/accounts/accountService';
import { TabView } from 'primeng/tabview';
import { LocationsService } from 'src/app/inventory/locations/locations.service';
import { ImportserialService } from 'src/app/modules/shared/services/importserial.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-accounts-full-details',
  templateUrl: './accounts-details.component.html',
  styleUrls: ['./accounts-details.component.scss'],
  providers: [LocationsService],
})
export class AccountsDetailsComponent implements OnInit, OnChanges {
  accountOpeningBalancetForm: FormGroup;
  accountOpeningBalance: boolean = false;
  isFlag: boolean = false

  displayInventoryOverview: boolean = false;
  inventoryOverviewRefId: number = 0;
  inventoryOverviewRefNumber: string = "";
  inventoryOverviewModule: string = "";

  isView: boolean = true;
  overviewRefId: number = 0;
  transactionMasterId: number = 0;
  overviewRefNumber: string = "";
  displayJournalEntryViewDialog: boolean = false;
  displayAddEditExpense: boolean = false;
  displayCreditCardViewDialog: boolean = false;
  displayBankRegisterViewDialog: boolean = false;
  displayWriteCheck: boolean = false;
  transactionNames = TransactionNames;
  displayInvoiceReceive = false;
  receivedPaymentId;
  @Input() channelName;
  receivePaymentDialogType = "";
  displayJournal: boolean = false;
  sortBy: string = '';
  isAscending: string = 'false';
  searchValue: string = '';
  searchColumns: string = '';
  allAccounts = [];
  totalRecord: number;
  isJEVoided: boolean = false;
  noCaseFindOrLoadingText = "Loading....";
  displaylocationView: boolean = false;
  location: any;
  configMenuItemsInvoicing;
  accountChannels = [];
  selectedData = null;
  selectedInvoicing;
  @Output() onSuccessfullAddEdit = new EventEmitter<typeJournalAddEditText>();


  @Input() hideAddEdit: boolean = false;
  @Input() configMenuItems;
  @Input() stagesCountN;
  @Input() isMenuShow;
  @Input() isLeftTableHide: boolean = false;
  @Output() getContextMenuOptions = new EventEmitter;
  @Output() closeSplitView = new EventEmitter;
  @Output() hideMenu = new EventEmitter;
  @Output() showMenu = new EventEmitter;

  @Output() tabhandleChange = new EventEmitter;
  @Input() selectedTabIndex = AccountViewTabIndex.OVERVIEW;
  @Input() savedDetailViewCols;
  @Input() accountNameData;
  @Input() selectedAccountFromTable;
  @Input() displayAccountDetails;
  @Output() onAccountDetailClose: EventEmitter<any> = new EventEmitter();

  @Input() readContactPermission;
  @Input() contactList;
  @Input() hasChildAccounts: boolean;
  @Output() hideFloathead = new EventEmitter();
  @Output() showFloathead = new EventEmitter();


  @Output() getDetailsForAccountContacts = new EventEmitter();
  @Output() onAddContact = new EventEmitter();
  @Input() addUpdateDone;
  @Output() postContactEdit = new EventEmitter();
  @Output() getAllContact = new EventEmitter();
  @Output() reloadDetails = new EventEmitter<any>();

  accountModuleId = AccountModuleId;
  accountViewTabIndex: any = AccountViewTabIndex;
  contactAssociationId = CONTACT_ASSOCIATION_ID.ACCOUNT;

  objectTypeId = 2;
  objectId = 0;

  displayTaskAdd = false;
  taskFromModule: boolean = false;


  pageNumber: number = 1;
  pageSize: number = 5;
  totalRecords: number = 0;
  documentsList: any[] = [];
  displayNewUpload = false;
  files = [];
  tempDuc: {
    attachmentId: number;
    idNo: string;
    name: string;
    uploadedDate: string;
    uploadedBy
  } = {
      "attachmentId": 0,
      "idNo": "",
      "name": "",
      "uploadedDate": "",
      "uploadedBy": ""
    };
  access = [
  ];

  filteredAccount;
  selectedAccount;
  activityLogList: any[] = [];
  selectedChannel: ChannelN;
  allowedExtensions = ['.png', '.jpg', '.jpeg', '.gif', '.txt', '.xls', '.xlsx', 'csv', '.doc', '.docx', '.ppt', '.pptx', 'pdf'];
  totalFileSize = 0;
  fileList: File[] = [];
  maxFilesizeErrorMessage = [];
  maxNoOfFilesErrorMessage = [];
  specialCharacterErrorMsg = [];
  erorMesg: any[] = [];
  newFileList: File[] = [];
  saveBtn: string = '';
  displayDocumentList: boolean = false;
  /* Subject to unsubscribe */
  private ngUnsubscribe = new Subject<void>();

  configMenuOrdersItems = [];
  showEstimateModule = false;
  showSOModule = false;
  showInvoiceModule = false;
  showCreditMemoModule = false;
  showReturnModule = false;

  opportunityReadPemission: boolean = false;
  casesReadPermission: boolean = false;
  transactionPermission: boolean = false;
  //    accountModuleId = AccountModuleId;
  templateSections: TemplateSection[] = [];
  noTemplateMessage: string = '';
  checkedFields: any = {};

  //finance
  column1: any[] = [];
  column2: any[] = [];
  financeCols2 = [
    { id: 1, name: "Opening Balance", columnName: "openingBalance", dragable: false, enabled: true, fieldDataType: "string" },
    { id: 2, name: "A/R Balance", columnName: "receivable", dragable: true, enabled: true, fieldDataType: "string" },
    { id: 3, name: "Past Due Balance", columnName: "pastDue", dragable: true, enabled: true, fieldDataType: "string" },
    { id: 4, name: "Credit Memo", columnName: "creditMemo", dragable: true, enabled: true, fieldDataType: "string" },
    { id: 5, name: "Account Name5", columnName: "accountName", dragable: true, enabled: true, fieldDataType: "string" },
    { id: 6, name: "Account Name6", columnName: "accountName", dragable: false, enabled: false, fieldDataType: "string" },
    { id: 7, name: "Account Name7", columnName: "accountName", dragable: true, enabled: true, fieldDataType: "string" },
    { id: 8, name: "Account Name8", columnName: "accountName", dragable: true, enabled: true, fieldDataType: "string" },
    { id: 9, name: "Account Name9", columnName: "accountName", dragable: true, enabled: true, fieldDataType: "string" },
    { id: 10, name: "Account Name10", columnName: "accountName", dragable: true, enabled: true, fieldDataType: "string" },
    { id: 11, name: "Account Name11", columnName: "accountName", dragable: true, enabled: true, fieldDataType: "string" },
    { id: 12, name: "Account Name12", columnName: "accountName", dragable: true, enabled: true, fieldDataType: "string" },
  ]
  financeCols = [];
  checkedCols: any[] = [];
  financeData;
  openingBalanceDate: Date;
  displayFinanceSetting = false;
  totalAmtForDetails: number = 0;
  maxCheckedFieldForDetails: boolean = false;
  updateColumnSettingsData: Partial<UpdateColumnSettings> = {};
  detailListSearchInput: string = '';

  transactionTypes = [
    { id: 0, name: "All" },
    { id: 1, name: "Invoice" },
    { id: 2, name: "Receive Payment" },
    { id: 3, name: "Credit Memo" },
    { id: 8, name: "Journal Entry" },
    { id: 9, name: "Expense" },
    { id: 11, name: "Bank Register" },
    { id: 18, name: "Sales Order" },
    { id: 19, name: "Estimate" },
    { id: 21, name: "Check" },
    { id: 24, name: "Credit Charges" },
    { id: 25, name: "Customer RMA" },
  ];

  filteredTransactionTypes: any[] = [];

  selectedTransaction = this.transactionTypes[0];
  selectedTransRow;
  displayPO = false;


  //sales history
  tabHeader: string = '';
  @ViewChild('transactionTab') tabView: TabView;
  activeIndex: number = 0;
  salesHistory = [];
  searchValueSales = "";
  totalRecordSales: number = 0;
  noSalesFindOrLoadingText;
  decimalPlaces: number = 0;
  qtyDecimal: number = 0;

  mergeAccountSequenceNumber: boolean = true;

  allTabList: DynamicTableWidgetDetailsM[]
  tabList: DynamicTableWidgetDetailsM[] = [];
  subTabList: DynamicTableWidgetDetailsM[] = [];
  activeTabIndex: number = -1;
  activeSubtabIndex: number = -1;

  constructor(
    public app: AppMainComponent,
    public appMainService: AppMainService,
    private activityService: ActivityService,
    private storeService: StoreService,
    private messageService: MessageService,
    private accountService: AccountServiceN,
    private accountService1: AccountService,
    private sharedChannelService: SharedChannelService,
    private accountServiceN: AccountServiceN,
    private documentViewerService: DocumentViewerService,
    private titlecasePipe: TitleCasePipe,
    private confirmationService: ConfirmationService,
    private permissionService: PermissionService,
    private sharedConfigService: SharedCRMConfigService,
    private accountHelper: AccountHelper, private financeService: FinanceService,
    private locationService: LocationsService,
    private configDefaultService: ConfigDefaultService,
    private importService: ImportserialService,
    private dynamicTableWidgetService: DynamicTableWidgetService
  ) { }

  ngOnInit(): void {
    this.filterByPermission();
    this.objectTypeId = this.app.allObjects && this.app.allObjects.length > 0 ? this.app.allObjects.filter(elem => elem.name ===
      "Account")[0].type : 0;
    this.getDecimalValue()
    this.getQtyDecimal();
    this.getAccountDetailsFromStore();
    this.getChannels();
    this.tabIndexByPermission(this.readContactPermission, this.opportunityReadPemission, this.casesReadPermission, this.transactionPermission);
    this.setPermissions();
    this.configMenuOrdersItems = [
      {
        label: 'Inventory',
        items: [{
          label: 'Estimates',
          command: () => {
            this.showEstimateModule = true;
            this.showSOModule = false;
            this.showInvoiceModule = false;
            this.showCreditMemoModule = false;
            this.showReturnModule = false;
          }
        },
        {
          label: 'Sales Order',
          command: () => {
            this.showEstimateModule = false;
            this.showSOModule = true;
            this.showInvoiceModule = false;
            this.showCreditMemoModule = false;
            this.showReturnModule = false;
          }
        },
        {
          label: 'Invoices',
          command: () => {
            this.showEstimateModule = false;
            this.showSOModule = false;
            this.showInvoiceModule = true;
            this.showCreditMemoModule = false;
            this.showReturnModule = false;
          }
        },
        {
          label: 'Credit Memo',
          command: () => {
            this.showEstimateModule = false;
            this.showSOModule = false;
            this.showInvoiceModule = false;
            this.showCreditMemoModule = true;
            this.showReturnModule = false;
          }
        },
        {
          label: 'Returns',
          command: () => {
            this.showEstimateModule = false;
            this.showSOModule = false;
            this.showInvoiceModule = false;
            this.showCreditMemoModule = false;
            this.showReturnModule = true;
          }
        },
        ]
      },
    ];
    this.fetchAllAccounts();

    this.configDefaultService.getMergeAccountSequenceNumber().then(response => {
      this.mergeAccountSequenceNumber = response?.enabled || false;
    });

  }

  getDecimalValue() {
    this.importService.getDecimalValue().subscribe(value => {
      if (value) {
        this.decimalPlaces = value;
      }
    })
  }

  getQtyDecimal() {
    this.importService.getQtyDecimalValue().subscribe(value => {
      if (value) {
        this.qtyDecimal = value;
      }
    })
  }

  setPermissions(): void {
    const userPermissions = this.permissionService.getPermissionData();

    if (userPermissions.length) {
      let contactPermission = userPermissions.find(obj => obj.objectName === ObjectNames.CONTACT);
      contactPermission = contactPermission.permissions.sort((a, b) => (a.permissionId < b.permissionId) ? - 1 : 1);
      this.readContactPermission = contactPermission && (contactPermission[0].permissionId == 1 && contactPermission[0].statusId == 1);

      let casesPermission = userPermissions.find(obj => obj.objectName === ObjectNames.CASES);
      casesPermission = casesPermission.permissions.sort((a, b) => (a.permissionId < b.permissionId) ? - 1 : 1);
      this.casesReadPermission = casesPermission && (casesPermission[0].permissionId == 1 && casesPermission[0].statusId == 1);

      let opportunityPermission = userPermissions.find(obj => obj.objectName === ObjectNames.OPPORTUNITY);
      opportunityPermission = opportunityPermission.permissions.sort((a, b) => (a.permissionId < b.permissionId) ? - 1 : 1);
      this.opportunityReadPemission = opportunityPermission && (opportunityPermission[0].permissionId == 1 && opportunityPermission[0].statusId == 1);

      const transactionPermission = userPermissions.find(obj => {
        if ([ObjectNames.Est_Menu_Object, ObjectNames.INVOICE, ObjectNames.SALES_ORDER, ObjectNames.CustomerRMA, ObjectNames.CM_Menu_Object].includes(obj.objectName)) {
          obj.permissions = obj.permissions.sort((a, b) => (a.permissionId < b.permissionId ? -1 : 1));
          return obj.permissions[0]?.permissionId === 1 && obj.permissions[0]?.statusId === 1;
        }
        return false;
      });

      this.transactionPermission = !!transactionPermission;

      this.tabIndexByPermission(this.readContactPermission, this.opportunityReadPemission, this.casesReadPermission, this.transactionPermission);


    }
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes.hasChildAccounts && changes.hasChildAccounts.currentValue) {
      this.hasChildAccounts = changes.hasChildAccounts.currentValue;
    }

    if (changes.contactList && changes.contactList?.currentValue) {
      this.contactList = changes.contactList?.currentValue;
    }
  }

  getItemMenu() {
    // setTimeout(() => {
    //     this.getContextMenuOptions.emit(this.filteredAccount);
    // }, 500);

    this.getContextMenuOptions.emit(this.filteredAccount);
  }

  closeSplitViewChild() {
    this.closeSplitView.emit();
  }

  getAccountContacts(e) {
    this.getDetailsForAccountContacts.emit(e);
  }

  addContact(e) {
    this.onAddContact.emit(e);
  }

  editContact(e) {
    this.postContactEdit.emit(e);
  }

  getAllContacts() {
    this.contactList = this.selectedAccount?.accountContacts || [];
    this.contactList.forEach(contactData => {
      contactData.contact.isPrimaryContact = contactData.isPrimaryContact;
      contactData.contact.childAccountAccess = contactData.childAccountAccess;
    });
    this.contactList = this.contactList.map(el => el.contact) || [];
  }

  contactDeleted(contatcDetails) {
    const getIndex = this.selectedAccount?.accountContacts.findIndex(el => el.id == contatcDetails.id);
    this.selectedAccount?.accountContacts.splice(getIndex, 1);
  }

  UpdateOpeningBalance(value: boolean) {
    this.accountOpeningBalance = value
    this.getFinanceData()
  }


  OpeningBalance() {
    this.accountOpeningBalance = true;
  }

  onRouteNavigation(event: any) {
    const rowData = event.data

    switch (rowData.transactionType) {
      case "Check":
        this.openWriteCheckDialog(rowData);
        break;
      case "Expense":
        this.openExpenseDialog(rowData);
        break;
      case "CreditCharges":
        this.openCreditChargeDialog(rowData);
        break;
      case "BankRegister":
        this.openBankRegisterDialog(rowData);
        break;
      case "ReceivePayment":
        this.openReceivePaymentrDialog(rowData);
        break;
      case "Journal":
        this.inventoryOverviewModule = TransactionNames.JournalEntry;
        this.showInventoryDialog(rowData);
        break;
      default:
        this.inventoryOverviewModule = TransactionNames[rowData.transactionType];
        this.showInventoryDialog(rowData);
    }
  }


  showInventoryDialog(rowData) {
    this.inventoryOverviewRefId = rowData.referenceId || rowData.id || rowData?.accMasterId || 0;
    this.inventoryOverviewRefNumber = rowData.referenceNo;
    this.selectedTransRow = rowData;
    this.displayInventoryOverview = true

  }


  openWriteCheckDialog(rowData: any) {
    this.overviewRefNumber = rowData.referenceNo;
    this.overviewRefId = rowData.referenceId
    this.displayWriteCheck = true;

  }
  onCloseWriteCheckDialog(e) {
    this.overviewRefId = 0;
    this.displayWriteCheck = false;
    this.getFinanceData()
  }

  openExpenseDialog(rowData: any) {
    this.overviewRefNumber = rowData.referenceNo;
    this.overviewRefId = rowData.referenceId
    this.displayAddEditExpense = true;
  }
  onCloseExpenseDialog(e) {
    this.overviewRefId = 0;
    this.displayAddEditExpense = false;
    this.getFinanceData();
  }

  openCreditChargeDialog(rowData: any) {
    this.overviewRefId = rowData.referenceId
    this.overviewRefNumber = rowData.referenceNo;
    this.displayCreditCardViewDialog = true;

  }
  onCloseCreditChargeDialog(e) {
    this.overviewRefId = 0;
    this.displayCreditCardViewDialog = false;
    this.getFinanceData();
  }

  openReceivePaymentrDialog(rowData: any) {
    this.receivedPaymentId = rowData.referenceId;
    this.displayInvoiceReceive = true;
    this.channelName = "Credit Memo"
    this.receivePaymentDialogType = ReceivePaymentDialogType.ViewPaymentDetails;
  }

  openBankRegisterDialog(rowData: any) {
    this.overviewRefId = rowData.referenceId
    this.overviewRefNumber = rowData.referenceNo;
    this.transactionMasterId = rowData.accMasterId;
    this.displayBankRegisterViewDialog = true;

  }
  onCloseBankRegisterViewDialog(e) {
    this.overviewRefId = 0;
    this.displayBankRegisterViewDialog = false;
    this.getFinanceData()
  }

  closeViewPopup() {
    this.displayInventoryOverview = false;
    this.getFinanceData()
  }

  onReceivePaymentsDialogClose(event) {
    this.displayInvoiceReceive = false;
    this.getFinanceData()
  }

  onCancelJournalView(e) {
    this.displayJournal = false;
  }

  checkVoidedJE(e) {
    this.isJEVoided = e;
  }

  showEditJournalEntry() {
    this.isView = false;
  }

  onSuccessfullJournalAdd(e: typeJournalAddEditText) {
    if (e == 'Edit') {
      this.isView = true;
    }
    this.getFinanceData();
    this.onSuccessfullAddEdit.emit(e);
    this.displayJournalEntryViewDialog = false;

  }

  onDialogClose(e) {
    this.displayJournalEntryViewDialog = false;
  }

  fetchAllAccounts() {
    this.sortBy = "order";
    this.isAscending = "true";
    let filter = "allfinancialaccounts";
    const data = {
      pageNo: this.pageNumber,
      pageSize: this.pageSize,
      searchValue: this.searchValue,
      searchColumns: this.searchColumns,
      sortBy: this.sortBy,
      isAscending: this.isAscending,
      filter: filter,
      isActive: true,
      showBalance: false,
    };
    this.getAllAccounts(data);
  }

  getAllAccounts(data) {
    this.appMainService.isShowSpinner("loadAccounts");
    this.accountService1
      .getAllAccountsWithPagination(data)
      .then((accounts) => {
        this.appMainService.isHideSpinner("loadAccounts");
        let { inventory, headers } = accounts;
        inventory = inventory == null ? [] : inventory;
        headers = headers == null ? [] : headers;
        this.totalRecord = headers["TotalCount"];
        this.noCaseFindOrLoadingText = "No Accounts found";
        this.allAccounts = inventory;

      })
      .finally(() => {
        this.appMainService.isHideSpinner("loadAccounts");
        this.noCaseFindOrLoadingText = "No Accounts found.";
      });
  }

  //userAccess
  getUserAcessList() {
    this.accountService.getUserAccess(this.selectedAccount.id).subscribe(userAccessData => {
      let accessData: any = [];
      accessData = userAccessData;
      this.access = this.convertTerritoryDataToPrimeNgTreeNodeModel(accessData);

    })

  }

  convertTerritoryDataToPrimeNgTreeNodeModel(originalData) {
    const convertedData = originalData?.map((item) => {
      const { children, ...data } = item;
      const childrenData =
        this.convertTerritoryDataToPrimeNgTreeNodeModel(
          children
        );

      const updatedChildrenData = childrenData?.map(child => {
        if (child.data && child.data.accessDetails) {
          child.data.accessType = child.data.accessDetails;
        }
        return child;
      });
      return {
        data: data,
        children: childrenData,
      };
    });
    return convertedData;
  }


  tabIndexByPermission(CONTACT: boolean = true, OPPORTUNITY: boolean = true, CASES: boolean = true, TRANSACTIONS: boolean = true) {
    this.accountViewTabIndex = ParseHelper.DeepCopy(AccountViewTabIndex);
    let index = -1;
    for (const key in this.accountViewTabIndex) {
      if ((key == 'CONTACT' && !CONTACT) || (key == 'OPPORTUNITY' && !OPPORTUNITY) || (key == 'CASES' && !CASES) || (key == 'TRANSACTIONS' && !TRANSACTIONS)) {
        this.accountViewTabIndex[key] = null;
      } else {
        index++;
        this.accountViewTabIndex[key] = index;
      }
    }
  }

  changeTab(e) {
    let index = e.index;
    this.selectedTabIndex = index;
    this.app.objectId = this.selectedAccount.id;
    this.app.objectType = "Account";

    if (index == this.accountViewTabIndex.CONTACT) {
      this.getAllContacts();
    } else if (index == this.accountViewTabIndex.UserAccess) {
      this.getUserAcessList();
    } else if (index == this.accountViewTabIndex.DOCUMENTS) {
      this.displayDocumentList = true;
    } else if (index == this.accountViewTabIndex.FINANCE) {
      this.getFinanceCol();
      this.getFinanceData();
    }

    this.tabhandleChange.emit(e);
  }

  getAccountDetailsFromStore(): void {
    this.storeService.getAccountData()
      .subscribe(accountData => {
        this.filteredAccount = ParseHelper.DeepCopy(accountData);
        this.selectedAccount = ParseHelper.DeepCopy(accountData);
        if (this.filteredAccount) {
          this.filteredAccount.createdDate = new LocalDatePipe().transform(this.filteredAccount.createdDate, 'date');
          this.filteredAccount.updatedDate = new LocalDatePipe().transform(this.filteredAccount.updatedDate, 'date');
          this.filteredAccount.stageChangedDate = new LocalDatePipe().transform(this.filteredAccount.stageChangedDate, 'date');
          this.activeTabIndex = -1;
          this.gettabList();
        }
      });
  }


  getAllDocumentsWithPagination(event?: LazyLoadEvent) {
    if (event) {
      this.pageSize = event.rows;
      this.pageNumber = (event.first / event.rows) + 1;
    }
    else {
      this.pageSize = 5;
      this.pageNumber = 1;
    }


    if (this.selectedTabIndex == this.accountViewTabIndex.DOCUMENTS) {
      this.getAccountDocumentList();
    }

  }

  getAccountDocumentList() {
    this.appMainService.isShowSpinner('getAccountDocumentList');
    let requesBody: {
      AccountId: number;
      AccountName: string;
      PageNumber: number;
      PageSize: number;
      LeadId?: number;
    } = {
      AccountId: this.selectedAccount?.id,
      AccountName: this.selectedAccount?.businessName,
      PageNumber: this.pageNumber,
      PageSize: this.pageSize,
      LeadId: this.selectedAccount?.leadId
    }
    this.accountServiceN.getAccountDocumentList(requesBody).subscribe({
      next: (data) => {
        this.documentsList = data?.body || [];
        const headers = data?.headers ? JSON.parse(data.headers.get('x-pagination')) : null;
        this.totalRecords = headers?.TotalCount || 0;
        this.appMainService.isHideSpinner('getAccountDocumentList');
      },
      error: (error: HttpErrorResponse) => {
        this.messageService.add({
          severity: Severity.Error,
          summary: this.titlecasePipe.transform(Severity.Error),
          detail: "Error occurred while saving data...",
        });
        this.appMainService.isHideSpinner('getAccountDocumentList');
      }
    })
  }


  editUpload(document) {
    this.saveBtn = 'edit';
    this.displayNewUpload = true;
    this.tempDuc = JSON.parse(JSON.stringify(document));
  }

  delUpload(product) {
    this.confirmationService.confirm({
      message: 'Do you want to delete this document?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.appMainService.isShowSpinner('deleteAccountDocument');
        this.accountServiceN.deleteAccountDocument(product?.attachmentId).subscribe({
          next: (data) => {
            let requesBody: {
              AccountId: number;
              AccountName: string;
              PageNumber: number;
              PageSize: number;
            } = {
              AccountId: this.selectedAccount?.id,
              AccountName: this.selectedAccount?.businessName,
              PageNumber: this.pageNumber,
              PageSize: this.pageSize,
            }
            this.getAccountDocumentList();
            this.appMainService.isHideSpinner('deleteAccountDocument');
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Document is successfully Deleted.'
            });
          },
          error: (error) => {
            this.appMainService.isHideSpinner('deleteAccountDocument');
            this.messageService.add({
              severity: 'error',
              summary: 'Error!',
              detail: 'Error occurring when loading accounts. Please try after sometime.'
            });
          },
        })
      },
      reject: () => {
      }
    });
  }

  editDocument() {
    let newName: string[] = this.tempDuc?.name.split(".");
    this.appMainService.isShowSpinner('editDocument');
    let requestBody: {
      attachmentId: number,
      name: string
    } = {
      attachmentId: this.tempDuc?.attachmentId,
      name: newName[0]
    }
    this.accountServiceN.editAccountDocument(requestBody).subscribe({
      next: (data) => {
        if (data?.isSuccessful) {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: data?.message
          });
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error!',
            detail: data?.message
          });
        }
        this.getAccountDocumentList();
        this.displayNewUpload = false;
        this.appMainService.isHideSpinner('editDocument');

      },
      error: (error) => {
        this.appMainService.isHideSpinner('editDocument');
        this.messageService.add({
          severity: 'error',
          summary: 'Error!',
          detail: 'Error occurring when loading data. Please try after sometime.'
        });
      },
    });
  }


  uploadAttachments(files: File[]) {
    this.appMainService.isShowSpinner('upload');
    if (typeof Worker !== undefined) {
      //  let errors = validateTotalFileSize(files, 25);
      for (let file of files) {
        let errors = validateFiles(file, 25, this.allowedExtensions);

        if (errors.length > 0) {
          for (let error of errors) {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: error.fileName + ": " + error.error
            });
          }

          this.appMainService.isHideSpinner('upload');
        } else {
          this.newFileList.push(file);
          uploadFiles(file, ({ name, content, size, extension }) => {
            this.totalFileSize += size;
            if (this.totalFileSize > 25000000) {
              this.maxFilesizeErrorMessage = [
                { severity: 'info', summary: 'Info', detail: 'Max File size should be less than 25Mb' }
              ];
            } else {
              this.fileList.push(file);
              this.maxFilesizeErrorMessage = [];
            }
            this.appMainService.isHideSpinner('upload');
          });
        }
      }
    } else {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: "Please update the browser. Web Workers are not supported in the older versions of this browser." });
    }

    if (this.newFileList.length > 3) {
      this.maxNoOfFilesErrorMessage = [
        { severity: 'info', summary: 'Info', detail: 'You can only upload 3 files in one go' }
      ];
    } else {
      this.maxNoOfFilesErrorMessage = []; // Remove the error message
    }
  }


  removeAllFiles() {
    this.fileList = [];
    this.files = [];
    this.newFileList = [];
    this.totalFileSize = 0;
    this.maxFilesizeErrorMessage = [];
    this.maxNoOfFilesErrorMessage = [];
  }

  removeFromUpload(file: File, uploader: FileUpload) {
    const index = uploader.files.indexOf(file);
    uploader.remove(null, index);
    this.totalFileSize = this.totalFileSize - file.size
    this.fileList = [];
    this.newFileList = [];
    for (let file of uploader.files) {
      this.fileList.push(file);
      this.newFileList.push(file);
    }
    if (uploader.files.length < 4) {
      this.maxNoOfFilesErrorMessage = [];
    }
    if (this.totalFileSize < 25000000) {
      this.maxFilesizeErrorMessage = [];
    }
    if (this.erorMesg.length > 0) {
      this.specialCharacterErrorMsg = [];
      this.erorMesg = [];
    }
  }

  addUpload() {
    this.saveBtn = 'upload';
    this.removeAllFiles();
    this.displayNewUpload = true;
    this.newFileList = [];
  }

  getFileIcon(fileName: string): string {
    const seperationIndex = fileName.lastIndexOf(".");
    const extension = fileName.substring(seperationIndex + 1).toLowerCase();
    return `${environment.assestsBasePath}icons/${extension}.png`;
  }

  save() {
    this.fileList.forEach((file: File, index: number) => {
      this.erorMesg[index] = this.checkSpecialCharacterInString(file?.name);
    })
    if (this.erorMesg.filter(data => data == true).length > 0) {
      this.specialCharacterErrorMsg = [
        { severity: 'info', summary: 'Info', detail: 'A file name can not contain any of the character % * <> ? | :' }
      ];
      return
    }
    let found: File[];

    this.appMainService.isShowSpinner('accountsDocumentUpload');
    let requesBody: FormData = new FormData();
    requesBody.append('AccountId', this.selectedAccount?.id);
    requesBody.append('ChannelId', this.selectedAccount?.typeId);
    requesBody.append('ChannelName', this.selectedChannel?.name);
    requesBody.append('AccountName', this.selectedAccount?.businessName);
    for (let file of this.fileList) {
      requesBody.append('Files', file);
    }
    if (this.documentsList == null) {
      this.documentSave(requesBody);
    } else {
      found = this.documentsList.filter((data) => {
        return this.fileList.find((item) => {
          return item?.name == data?.name
        })
      });
      if (found.length != 0) {
        this.appMainService.isHideSpinner('accountsDocumentUpload');
        this.messageService.add({
          severity: 'error',
          summary: 'Error!',
          detail: 'This Document name is already exist.'
        });
      } else {
        this.documentSave(requesBody)
      }
    }
  }

  checkSpecialCharacterInString(inputString): any {
    // Define a regular expression pattern to match special characters
    // const specialCharacterPattern = /[/\?*"<>|:%]/;
    const specialCharacterPattern = /[\/\\?*"<>\|:%\x00-\x1F]/;
    const myArray: string[] = inputString.split(".");
    // Use the test method of the regular expression to check if the inputString contains a special character
    return specialCharacterPattern.test(myArray[0]);
  }

  documentSave(requesBody) {
    this.accountServiceN.accountsDocumentsUpload(requesBody).subscribe({
      next: (response) => {
        this.appMainService.isHideSpinner('accountsDocumentUpload');
        this.displayNewUpload = false;
        if (this.erorMesg.length > 0) {
          this.specialCharacterErrorMsg = [];
          this.erorMesg = [];
        }
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Document is successfully uploaded!!'
        });
        this.getAccountDocumentList();
      },
      error: (error) => {
        this.appMainService.isHideSpinner('accountsDocumentUpload');
        this.messageService.add({
          severity: 'error',
          summary: 'Error!',
          detail: 'Error occurring when loading data. Please try after sometime.'
        });
      },
    })
  }

  getChannels() {
    this.appMainService.isShowSpinner('getChannelDataList');
    this.sharedChannelService.getChannels(2).subscribe({
      next: (data: ChannelN[]) => {
        this.selectedChannel = data.find((item: ChannelN) => {
          return item?.id == this.selectedAccount?.typeId
        });
        this.getTemplateFormFields(this.selectedChannel?.id);
        this.appMainService.isHideSpinner('getChannelDataList');
      },
      error: (error) => {
        this.appMainService.isHideSpinner('getChannelDataList');
        this.messageService.add({
          severity: 'error',
          summary: 'Error!',
          detail: 'Error occurring when loading accounts. Please try after sometime.'
        });
      },
    })
  }

  //    downloadedLink:string;
  downloadLink(product) {
    this.appMainService.isShowSpinner('downloadLink');
    let requestBody: {
      id: number;
      isDefaultContentType: boolean
    } = {
      id: product?.attachmentId,
      isDefaultContentType: true
    }
    this.accountServiceN.downloadFilesAndFolder(requestBody).subscribe({
      next: (data) => {
        // this.downloadedLink = data?.downloadLink
        this.downloadedFile(data?.downloadLink);
        this.appMainService.isHideSpinner('downloadLink');
      },
      error: (error: HttpErrorResponse) => {
        this.appMainService.isHideSpinner('downloadLink');
        this.messageService.add({
          severity: Severity.Error,
          summary: this.titlecasePipe.transform(Severity.Error),
          detail: "Error occurred while saving data...",
        });
      }
    })
    // if(link){
    //     this.messageService.add({
    //         severity: 'success',
    //         summary: 'Success',
    //         detail: 'Document is successfully downloaded!!'
    //     });
    // }
  }

  downloadedFile(url: string) {
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    // the filename you want
    a.download = 'todo-1.json';
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
  }

  openFilePreview(product) {
    this.appMainService.isShowSpinner('openFilePreview');
    let docType: string = product?.extension;
    let requestBody: {
      id: number;
      isDefaultContentType: boolean
    } = {
      id: product?.attachmentId,
      isDefaultContentType: false
    }
    this.accountServiceN.downloadFilesAndFolder(requestBody).subscribe({
      next: (data) => {
        switch (docType) {
          case 'docx':
            this.documentViewerService.selectDocumentType(docType, data?.encodedDownloadLink);
            break;
          case 'xlsx':
            this.documentViewerService.selectDocumentType(docType, data?.encodedDownloadLink);
            break;
          case 'pptx':
            this.documentViewerService.selectDocumentType(docType, data?.encodedDownloadLink);
            break;
          case 'csv':
            this.documentViewerService.selectDocumentType(docType, data?.encodedDownloadLink);
            break;
          case 'pdf':
            this.documentViewerService.selectDocumentType(docType, data?.downloadLink);
            break;
          case 'jpg':
            this.documentViewerService.selectDocumentType(docType, data?.downloadLink);
            break;
          case 'png':
            this.documentViewerService.selectDocumentType(docType, data?.downloadLink);
            break;
          case 'gif':
            this.documentViewerService.selectDocumentType(docType, data?.downloadLink);
            break;
          case 'txt':
            this.documentViewerService.selectDocumentType(docType, data?.downloadLink);
            break;
          default:
            this.documentViewerService.selectDocumentType(docType, data?.downloadLink);
        }
        this.appMainService.isHideSpinner('openFilePreview');
      },
      error: (error: HttpErrorResponse) => {
        this.appMainService.isHideSpinner('openFilePreview');
        this.messageService.add({
          severity: Severity.Error,
          summary: this.titlecasePipe.transform(Severity.Error),
          detail: "Error occurred while saving data...",
        });
      }
    })
    // this.documentViewerService.selectDocumentType(docType,product?.downloadLink)
  }

  getTemplateFormFields(channelId: number): void {
    const globalChannelId = this.permissionService.getGlobalChannelId();
    this.appMainService.isShowSpinner('getTemplateFormFields');
    this.sharedConfigService
      .getTemplateFormFields(this.accountModuleId, channelId || globalChannelId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (response) => {
          this.templateSections = response || [];
          this.markCheckedFields();
        },
        error: () => {
          this.templateSections = [];
          this.noTemplateMessage = 'Error loading template under this channel.';
        },
        complete: () => {
          this.appMainService.isHideSpinner('getTemplateFormFields');
        },
      });
  }

  markCheckedFields(): void {
    for (const section of this.templateSections) {
      for (const fieldData of section.fields) {
        if (fieldData.name) {
          if (fieldData.childFields?.length) {
            fieldData.name = this.accountHelper.processFieldName(
              fieldData.name
            );

            this.checkedFields[fieldData.name] = {
              labelName: fieldData.labelName,
            };

            for (const childFieldData of fieldData.childFields) {
              childFieldData.name = this.accountHelper.processFieldName(
                childFieldData.name
              );

              if (
                section.name === Sections.CONTACT_DETAILS &&
                fieldData.name === 'SocialProfile'
              ) {
                childFieldData.name = 'Contact' + childFieldData.name;
              } else if (
                section.name === Sections.ACCOUNT_DETAILS &&
                fieldData.name === 'AccountSocial'
              ) {
                childFieldData.name = 'Account' + childFieldData.name;
              }

              this.checkedFields[childFieldData.name] = {
                labelName: childFieldData.labelName,
              };
            }
          } else {
            fieldData.name = this.accountHelper.processFieldName(
              fieldData.name
            );

            if (
              fieldData.name == 'AccountEmail' ||
              fieldData.name == 'AccountPhone'
            ) {
              continue;
            }

            this.checkedFields[fieldData.name] = {
              labelName: fieldData.labelName,
            };
          }
        }
      }
    }
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
  menuShow(type: 'menu' | 'table') {
    this.showMenu.emit(type);
    this.hideFloathead.emit();
    if (type == "menu") {
      setTimeout(() => {
        this.showFloathead.emit();
      }, 100);
    }
  }
  menuHide(type: 'menu' | 'table') {
    this.hideFloathead.emit();
    this.hideMenu.emit(type);
    if (type == "menu") {
      setTimeout(() => {
        this.showFloathead.emit();
      }, 100);
    }
  }

  //finance
  getFinanceData() {
    this.accountService.getFinance(this.selectedAccount.id, this.selectedTransaction.id)
      .subscribe({
        next: (response) => {
          this.financeData = response;
          if (this.financeData) {
            this.financeData.txnList = this.financeData?.txnList?.map(ele => ({
              ...ele,
              processedDate: ele?.txnDate ? this.app._showDateTimeWithZone(ele?.txnDate) : this.app._showDateTimeWithZone(new Date()),
            }));
            this.openingBalanceDate = this.app._showDateTimeWithZone(response?.asOfDate);
          }
        },
        error: () => {
          this.templateSections = [];
          this.noTemplateMessage = 'Error loading ...';
        },
        complete: () => {
          this.appMainService.isHideSpinner('getFinanceCols');
        },
      });
  }
  getFinanceCol() {
    this.financeCols = [
      { id: 1, name: "Opening Balance", columnName: "openingBalance" },
      { id: 2, name: "A/R Balance", columnName: "arBalance" },
      { id: 3, name: "Past Due Balance", columnName: "pastDueBalance" },
      { id: 4, name: "Credit Memo", columnName: "creditMemo" },
    ]
    //this.checkedCols = this.financeCols.filter(e => e.enabled);
    this.checkedCols = JSON.parse(JSON.stringify(this.financeCols));
    if (this.checkedCols.length > 6) {
      this.column1 = this.checkedCols.slice(0, 6);
      this.column2 = this.checkedCols.slice(6, 12);
    } else {
      this.column1 = this.checkedCols;
      this.column2 = [];
    }
  }
  financeSetting() {
    this.displayFinanceSetting = true;
  }
  dropCol(event: CdkDragDrop<string[]>) {
    if (event.currentIndex > 0)
      moveItemInArray(this.financeCols, event.previousIndex, event.currentIndex);
  }
  checkUncheckField(isChecked: boolean, obj: any): void {
    if (isChecked) {
      if (this.totalAmtForDetails <= 12) {
        this.totalAmtForDetails++;
      }
    }
    else {
      this.totalAmtForDetails--;
    }
    this.maxCheckedFieldForDetails = this.totalAmtForDetails >= 12;

    if (obj) {
      this.updateDetailsViewSectionFields(obj);
    }
  }
  updateDetailsViewSectionFields(obj: any): void {
    let selectedField: any;
    let storedField: any;
    let foundIndex: number;

    foundIndex = this.updateColumnSettingsData?.detailsViewFields.findIndex(
      (x) => x?.id == obj?.id
    );

    if (selectedField.enabled !== storedField.enabled ||
      selectedField.displayOrder !== storedField.displayOrder) {
      let fieldData: UpdateFields = {
        id: obj?.id,
        enabled: obj?.enabled,
        displayOrder: obj?.displayOrder,
      };

      if (foundIndex === -1) {
        this.updateColumnSettingsData.detailsViewFields.push(fieldData);
      } else {
        this.updateColumnSettingsData.detailsViewFields[foundIndex] = fieldData;
      }
    } else {
      if (foundIndex > -1) {
        this.updateColumnSettingsData.detailsViewFields.splice(foundIndex, 1);
      }
    }
  }
  onRowSelectTrans() {
    this.displayPO = true;
    //open different view popup by transactionType
  }

  //sales history
  onTabChange(event) {
    this.tabHeader = this.tabView?.tabs[this.activeIndex]?.header;
    switch (this.tabHeader) {
      case 'Sales History':
        let sdata = {
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
          value: this.searchValueSales
        }
        this.getSalesHistory(sdata);
        break;
    }
  }
  getSalesHistory(data) {
    this.accountService.getSalesHistory(this.selectedAccount.id, data.pageNumber, data.pageSize, data.value)
      .then((sales) => {
        let { data, headers } = sales;
        data = data == null ? [] : data;
        headers = headers == null ? [] : headers;
        this.totalRecordSales = headers["TotalCount"];
        this.salesHistory = data;
        this.appMainService.isHideSpinner('sales history');

      })
      .finally(() => {
        this.noSalesFindOrLoadingText = "No Sales History found.";
        this.appMainService.isHideSpinner('bin');
      });
  }

  openLocationDialog(id) {
    this.displaylocationView = false;
    this.locationView(id)
  }

  locationView(id) {
    this.locationService.getLocationById(id).subscribe((location) => {
      this.location = location;
      this.displaylocationView = true;
    });
  }

  closeLocationView(data: any) {
    this.onTabChange(event)
    this.displaylocationView = data;
  }

  //#region dynamic tab list

  gettabList() {
    if (this.tabList?.length || this.subTabList?.length) {
      this.filterTabAndSubTabList();
      return;
    }
    this.dynamicTableWidgetService.getWidgets(AccountModuleId, this.filteredAccount?.typeId).pipe(take(1)).subscribe({
      next: (response) => {
        this.allTabList = response || [];
        this.filterTabAndSubTabList();
      },
      error: (error) => {

      }
    })
  }

  filterTabAndSubTabList() {
    this.getTabListFilterValues(this.allTabList);
    this.tabList = this.allTabList.filter(t => t.widgetType == 'Tab');
    this.subTabList = this.allTabList.filter(t => t.widgetType == 'Sublist');
  }

  getTabListFilterValues(allTabList: DynamicTableWidgetDetailsM[]) {
    allTabList.map(tab => {
      const moduleColumn = this.savedDetailViewCols.find(col => col?.id == tab.associationFieldId);
      let values: string[] = [];

      if (moduleColumn?.columnName && this.filteredAccount?.[moduleColumn.columnName]) {
        const columnValue = this.filteredAccount[moduleColumn.columnName];
        if (typeof columnValue === 'string') {
          if ([FormControlList.MultipleDropDownList, FormControlList.CheckBox].includes(moduleColumn.formControlType) && moduleColumn.columnName !== 'tags') {
            const splitedValues = columnValue.split(",");
            splitedValues?.map(v => values.push(v.trim()));
          }
          else if (moduleColumn.columnName === 'currencyName') {
            if (this.filteredAccount?.currencyName) {
              const currencyUnit = this.filteredAccount?.currencyUnit;
              const currencyValue = `${currencyUnit.name} - ${currencyUnit.code}`;
              values.push(currencyValue);
            }
          }
          else if (moduleColumn.columnName === 'businessName') {
            values.push(columnValue);
          }
          else if (moduleColumn.columnName === 'tags') {
            const tags = this.filteredAccount[moduleColumn.columnName];
            tags.forEach(tag => {
              if (tag.name) {
                values.push(tag.name);
              }
            });
          }
          else {
            values.push(columnValue);
          }
        }
        else if (Array.isArray(columnValue)) {
          const names = columnValue.map(item => item.name).join(",");
          const splitedValues = names.split(",");
          splitedValues?.map(v => values.push(v.trim()));
        }
        else if (moduleColumn.columnName === 'contactphonework') {
          if (this.filteredAccount?.accountContacts && this.filteredAccount?.accountContacts?.length > 0) {
            this.filteredAccount?.accountContacts?.forEach(accountContact => {
              accountContact?.contact?.contactPhones?.forEach(contactDetails => {
                if (contactDetails?.phone.phoneTypeId == PHONE_TYPE_IDS.WORK) {
                  const phoneNumber = contactDetails?.phone?.code ? `${contactDetails.phone.code}${contactDetails.phone.number}` : `${contactDetails.phone.number}`;
                  values.push(phoneNumber);
                }
              });
            });
          }
        }
        else if (moduleColumn.columnName === 'contactphonemobile') {
          if (this.filteredAccount?.accountContacts && this.filteredAccount?.accountContacts?.length > 0) {
            this.filteredAccount?.accountContacts?.forEach(accountContact => {
              accountContact?.contact?.contactPhones?.forEach(contactDetails => {
                if (contactDetails?.phone.phoneTypeId == PHONE_TYPE_IDS.MOBILE) {
                  const phoneNumber = contactDetails?.phone?.code ? `${contactDetails.phone.code}${contactDetails.phone.number}` : `${contactDetails.phone.number}`;
                  values.push(phoneNumber);
                }
              });
            });
          }
        }
        else if (moduleColumn.columnName === 'contactphonehome') {
          if (this.filteredAccount?.accountContacts && this.filteredAccount?.accountContacts?.length > 0) {
            this.filteredAccount?.accountContacts?.forEach(accountContact => {
              accountContact?.contact?.contactPhones?.forEach(contactDetails => {
                if (contactDetails?.phone.phoneTypeId == PHONE_TYPE_IDS.HOME) {
                  const phoneNumber = contactDetails?.phone?.code ? `${contactDetails.phone.code}${contactDetails.phone.number}` : `${contactDetails.phone.number}`;
                  values.push(phoneNumber);
                }
              });
            });
          }
        }
        else if (moduleColumn.columnName === 'contactphonecp1') {
          if (this.filteredAccount?.accountContacts && this.filteredAccount?.accountContacts?.length > 0) {
            this.filteredAccount?.accountContacts?.forEach(accountContact => {
              accountContact?.contact?.contactPhones?.forEach(contactDetails => {
                if (contactDetails?.phone.phoneTypeId == PHONE_TYPE_IDS.CP1) {
                  const phoneNumber = contactDetails?.phone?.code ? `${contactDetails.phone.code}${contactDetails.phone.number}` : `${contactDetails.phone.number}`;
                  values.push(phoneNumber);
                }
              });
            });
          }
        }
        else if (moduleColumn.columnName === 'contactphonecp2') {
          if (this.filteredAccount?.accountContacts && this.filteredAccount?.accountContacts?.length > 0) {
            this.filteredAccount?.accountContacts?.forEach(accountContact => {
              accountContact?.contact?.contactPhones?.forEach(contactDetails => {
                if (contactDetails?.phone.phoneTypeId == PHONE_TYPE_IDS.CP2) {
                  const phoneNumber = contactDetails?.phone?.code ? `${contactDetails.phone.code}${contactDetails.phone.number}` : `${contactDetails.phone.number}`;
                  values.push(phoneNumber);
                }
              });
            });
          }
        }
        else {
          values.push(String(columnValue));
        }
      }
      tab.associationFieldDetails = moduleColumn;
      tab.values = values;
    });
  }

  selectSubTab(index: number) {
    this.activeTabIndex = index;
  }

  deleteSublist(sublistDetails: DynamicTableWidgetDetailsM, isSubtab: boolean = false) {
    this.confirmationService.confirm({
      message: 'Do you want to remove this Tab?',
      header: 'Remove Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.dynamicTableWidgetService.deleteWidget(sublistDetails.widgetId).subscribe({
          next: (response) => {
            this.appMainService.hideAllSpinner();
            if (isSubtab) {
              this.subTabList = this.subTabList.filter(t => t.widgetId !== sublistDetails.widgetId);
              this.activeSubtabIndex = -1;
            } else {
              this.tabList = this.tabList.filter(t => t.widgetId !== sublistDetails.widgetId);
              this.selectedTabIndex = 0;
              this.activeTabIndex = -1;
            }
            this.messageService.add({ severity: 'success', summary: 'Tab Removed', detail: 'Tab removed successfully!' });
          },
          error: (error) => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while saving data...' });
          }
        })
      },
      reject: () => {
      }
    });
  }


  filterByPermission() {
    const allowedObjectNames = [
      ObjectNames.INVOICE,
      ObjectNames.RECEIVE_PAYMENT,
      ObjectNames.CM_Menu_Object,
      ObjectNames.JOURNAL,
      ObjectNames.EXPENSE,
      ObjectNames.BANK_REGISTER,
      ObjectNames.SALES_ORDER,
      ObjectNames.ESTIMATE,
      ObjectNames.CHECK,
      ObjectNames.CREDIT_CHARGES,
      ObjectNames.CustomerRMA,
    ];
    const userPermissions = this.permissionService.getPermissionData();

    // Iterate through userPermissions and check active permissions
    const transactionPermissions = userPermissions.filter(permissionObj =>
      allowedObjectNames.includes(permissionObj.objectName) &&
      permissionObj.permissions.some(permission => permission.statusId === 1)
    );

    // Extract transaction types where names match object names
    const allowedTransactionNames = transactionPermissions.map(permission => permission.objectName);

    this.filteredTransactionTypes = this.transactionTypes.filter(transaction =>
      transaction.name === "All" || allowedTransactionNames.includes(transaction.name)
    );
  }


  //#endregion dynamic tab list
}
